//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types

export const OBTENER_BOLETAS_MUNI = "obtenerBoletasMuni";
export const ASIGNAR_BOLETA_MUNI = "asignarBoletaMuni";
export const OBTENER_BOLETA_MUNI = "obtenerBoletaMuni";
export const ACTUALIZAR_ASIGNACION = "actualizarBoletaMuni";

export const OBTENER_BOLETAS_MUNI_POR_PERIODO_INDICE_DEPTO = "obtenerBoletasMuniPorPeriodoIndiceDepto";

export const OBTENER_BOLETAS_POR_MUNI_REVISOR_PERIODO = "obtenerBoeltasMuniRevisorPeriodo";
export const OBTENER_BOLETAS_POR_MUNI_APROBADOR_PERIODO = "obtenerBoletasMuniAprobadorPeriodo";


export const OBTENER_BOLETAS_POR_MUNI = "obtenerBoletasMuni";
// mutation types
export const SET_BOLETAS = "setBoletas";
export const SET_BOLETA = "setBoleta";
export const SET_BOLETAS_MUNI  = "setBoletasMuni";

const state = {
    boletas:[],
    boleta:[],  
    boletasMuni:[]  
}

const getters = {
    obtenerBoletasMuni(state) {
      return state.boletas;
    },
}

const actions = {

   
    /**
     * Obtener las boletas asignadas a las municipalidades
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    
    async [OBTENER_BOLETAS_MUNI](context, estadoId) {
        console.log(estadoId)
        let endpoint = `api/BoletaMuni`;
        if(estadoId>0){
            endpoint = `api/BoletaMuni/Estado/${estadoId}`
        }
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_BOLETAS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },


    /**
     * Obtener las boletas asignadas a las municipalidades por periodo, indice y depto, enviar 0 en indices para obviar el filtro
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    
     async [OBTENER_BOLETAS_MUNI_POR_PERIODO_INDICE_DEPTO](context, datos) {
       // console.log(datos)
        let endpoint = `api/BoletaMuni/all/${datos.idPeriodo}/${datos.idIndice}/${datos.idDepto}`;
        
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_BOLETAS_MUNI, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    /**
     * Asignar boleta a municipalidades de forma parcial o para todas las munis
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [ASIGNAR_BOLETA_MUNI](context, datos){

        let endpoint=`/api/BoletaMuni/all/asignar`;
        
        //?Si el tipo es 2, es de forma parcial
        if(datos.tipo===2){
            endpoint=`api/BoletaMuni/partial/asignar`;
        }


        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=${endpoint}`, datos)
                .then(({ data }) => {
                    context.commit(SET_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        }); 
         
    },

    
    async [OBTENER_BOLETA_MUNI](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/BoletaMuni/`)
                .then(({ data }) => {
                    context.commit(SET_BOLETAS,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    /**
     * Obtener las boletas asignadas a cada municipalidades
     * @param {*} context 
     * @param {*} id 
     * @returns 
     */
    async [OBTENER_BOLETAS_POR_MUNI](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/BoletaMuni/all/`)
                .then(({ data }) => {
                    context.commit(SET_BOLETA,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    async [ACTUALIZAR_ASIGNACION](context, datos){
        //console.log("Aqui tambien")
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/BoletaMuni/`, datos)
                .then(({ data }) => {
                    context.commit(SET_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },



    /**
     * Obtener las boletas asignadas a la municipalidad por periodo y revisor id
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_BOLETAS_POR_MUNI_REVISOR_PERIODO](context, datos){
       
        let endpoint = `api/BoletaMuni/Muni/Periodo/Revisor/${Number(datos.idMuni)}/${Number(datos.idPeriodo)}/${Number(datos.idRevisor)}`;

        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_BOLETAS,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    /**
     * 
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_BOLETAS_POR_MUNI_APROBADOR_PERIODO](context, datos){
       
        let endpoint = `api/BoletaMuni/Muni/Periodo/Aprobador/${Number(datos.idMuni)}/${Number(datos.idPeriodo)}/${Number(datos.idAprobador)}`;

        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_BOLETAS,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    }

    
}

const mutations = {
    [SET_BOLETAS](state, data) {
        state.boletas = data;
    },

    [SET_BOLETA](state, data) {
        state.boleta = data;
    },

    [SET_BOLETAS_MUNI](state, data) {
        state.boletasMuni = data;
    },

}


export default {
    state,
    getters,
    actions,
    mutations
}